import React, { Children } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Plus, ArrowUpRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { BottomNav } from '../components/BottomNav';
import { OrderCard } from '../components/OrderCard';
import { orders, walletBalance } from '../data/mockData';
export function Dashboard() {
  const navigate = useNavigate();
  const recentOrders = orders.slice(0, 4);
  const stats = {
    totalSales: 213,
    activeOrders: orders.filter(o => o.status === 'pending' || o.status === 'processing').length,
    completedOrders: orders.filter(o => o.status === 'completed').length
  };
  return <div className="min-h-screen pb-24" data-id="element-137">
      <div className="max-w-md mx-auto" data-id="element-138">
        {/* Header */}
        <div className="flex justify-between items-center p-5 pt-8" data-id="element-139">
          <div data-id="element-140">
            <p className="text-label mb-1" data-id="element-141">Good morning,</p>
            <h1 className="text-white text-2xl font-bold tracking-tight" data-id="element-142">
              KDX Reseller Panel
            </h1>
          </div>
          <button className="w-10 h-10 rounded-full glass-card flex items-center justify-center hover:bg-white/[0.08] transition-colors" data-id="element-143">
            <Bell className="w-5 h-5 text-white" data-id="element-144" />
          </button>
        </div>

        <div className="px-5 space-y-5" data-id="element-145">
          {/* Premium Wallet Balance Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-gradient-to-br from-[#00D68F] to-[#00B377] rounded-[24px] p-6 relative overflow-hidden shadow-[0_10px_40px_-10px_rgba(0,214,143,0.3)]" data-id="element-146">
            {/* Decorative elements */}
            <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-white/10 blur-2xl" data-id="element-147" />
            <div className="absolute -bottom-8 -left-8 w-32 h-32 rounded-full bg-white/10 blur-xl" data-id="element-148" />

            <div className="relative z-10" data-id="element-149">
              <p className="text-white/70 text-xs tracking-widest uppercase font-semibold mb-2" data-id="element-150">
                Available Balance
              </p>
              <h2 className="text-white text-[40px] leading-none font-bold tracking-tight mb-8" data-id="element-151">
                ₦{walletBalance.available.toLocaleString()}
              </h2>

              <div className="flex justify-between items-end" data-id="element-152">
                <div className="flex gap-1" data-id="element-153">
                  <div className="w-1.5 h-1.5 rounded-full bg-white/60" data-id="element-154" />
                  <div className="w-1.5 h-1.5 rounded-full bg-white/60" data-id="element-155" />
                  <div className="w-1.5 h-1.5 rounded-full bg-white/60" data-id="element-156" />
                  <div className="w-1.5 h-1.5 rounded-full bg-white/60" data-id="element-157" />
                </div>
                <span className="text-white/40 text-sm font-bold tracking-widest" data-id="element-158">
                  KDX
                </span>
              </div>
            </div>
          </motion.div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-3" data-id="element-159">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="glass-card p-4" data-id="element-160">
              <div className="flex items-center gap-1.5 mb-2" data-id="element-161">
                <div className="w-1.5 h-1.5 rounded-full bg-[#00D68F]" data-id="element-162" />
                <p className="text-[#64748B] text-[10px] uppercase tracking-wider font-semibold" data-id="element-163">
                  Sales
                </p>
              </div>
              <p className="text-white text-2xl font-bold tracking-tight" data-id="element-164">
                {stats.totalSales}
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="glass-card p-4" data-id="element-165">
              <div className="flex items-center gap-1.5 mb-2" data-id="element-166">
                <div className="w-1.5 h-1.5 rounded-full bg-[#4CC9F0]" data-id="element-167" />
                <p className="text-[#64748B] text-[10px] uppercase tracking-wider font-semibold" data-id="element-168">
                  Active
                </p>
              </div>
              <p className="text-white text-2xl font-bold tracking-tight" data-id="element-169">
                {stats.activeOrders}
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="glass-card p-4" data-id="element-170">
              <div className="flex items-center gap-1.5 mb-2" data-id="element-171">
                <div className="w-1.5 h-1.5 rounded-full bg-[#FFBE0B]" data-id="element-172" />
                <p className="text-[#64748B] text-[10px] uppercase tracking-wider font-semibold" data-id="element-173">
                  Done
                </p>
              </div>
              <p className="text-white text-2xl font-bold tracking-tight" data-id="element-174">
                {stats.completedOrders}
              </p>
            </motion.div>
          </div>

          {/* Quick Actions */}
          <div className="grid grid-cols-2 gap-3" data-id="element-175">
            <motion.button initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} whileTap={{
            scale: 0.97
          }} onClick={() => navigate('/products/upload')} className="glass-card border-[#00D68F]/30 p-4 flex items-center justify-center gap-2 text-[#00D68F] font-semibold shadow-[0_0_15px_rgba(0,214,143,0.08)] hover:bg-[#00D68F]/10 transition-colors" data-id="element-176">
              <Plus className="w-5 h-5" data-id="element-177" />
              Add Product
            </motion.button>

            <motion.button initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5
          }} whileTap={{
            scale: 0.97
          }} onClick={() => navigate('/wallet/withdraw')} className="glass-card border-[#00D68F]/30 p-4 flex items-center justify-center gap-2 text-[#00D68F] font-semibold shadow-[0_0_15px_rgba(0,214,143,0.08)] hover:bg-[#00D68F]/10 transition-colors" data-id="element-178">
              <ArrowUpRight className="w-5 h-5" data-id="element-179" />
              Withdraw
            </motion.button>
          </div>

          {/* Recent Orders */}
          <div className="pt-2" data-id="element-180">
            <div className="flex justify-between items-center mb-4" data-id="element-181">
              <h3 className="text-label" data-id="element-182">Recent Orders</h3>
              <button onClick={() => navigate('/orders')} className="text-[#00D68F] text-sm font-medium hover:text-[#00B377] transition-colors" data-id="element-183">
                View All
              </button>
            </div>

            <motion.div initial="hidden" animate="visible" variants={{
            visible: {
              transition: {
                staggerChildren: 0.1
              }
            }
          }} className="space-y-3" data-id="element-184">
              {recentOrders.map(order => <motion.div key={order.id} variants={{
              hidden: {
                opacity: 0,
                y: 20
              },
              visible: {
                opacity: 1,
                y: 0
              }
            }} data-id="element-185">
                  <OrderCard order={order} data-id="element-186" />
                </motion.div>)}
            </motion.div>
          </div>
        </div>
      </div>

      <BottomNav data-id="element-187" />
    </div>;
}